import { IConfigSlider } from './custom-range-slider';

// NOTE: The label is the main part of a variable name that would be sent to the backend. It should start from the capital later.
//  Final variables will be named "lower*" and "upper*"

export const heatScore: IConfigSlider[] = [
  {
    min: 0,
    max: 100,
    label: 'HeatScore',
    postfix: '%',
  },
];

export const wages: IConfigSlider[] = [
  {
    formName: 'Wages',
    // Mirrors the backend-generated Detailed Financials "Wages And Salaries"
    // slider (LARGE_POSITIVE_FINANCIAL_STEPS in ui_components.py). The scale
    // and maxPostfix must match: the backend only ignores the upper bound when
    // it is null or equals the top step, so a smaller max here would silently
    // cap results at that value whenever only a lower bound is set.
    min: 0,
    max: 100000000000,
    steps: [
      0, 10000, 100000, 250000, 500000, 1000000, 2500000, 5000000, 10000000,
      25000000, 50000000, 100000000, 250000000, 500000000, 1000000000,
      10000000000, 100000000000,
    ],
    maxPostfix: '+',
    // The backend financial filter is "Wages And Salaries", so the sent keys
    // must be `lowerWages And Salaries`/`upperWages And Salaries`. `formName`
    // keeps the UI label short ("Wages").
    label: 'Wages And Salaries',
    prefix: '£',
  },
];


export const numberOfActiveTrademarks: IConfigSlider[] = [
  {
    formName: 'Number Of Active Trademarks',
    min: 0,
    max: 100,
    label: 'NumberOfActiveTrademarks',
  },
];

export const fleet: IConfigSlider[] = [
  {
    formName: 'Vehicle Fleet Size',
    min: 0,
    max: 10000,
    label: 'VehicleFleetSize',
  },  {
    formName: 'Vehicle Fleet Size Authorised',
    min: 0,
    max: 10000,
    label: 'VehicleFleetSizeAuthorised',
  },  {
    formName: 'Trailer Fleet Size',
    min: 0,
    max: 10000,
    label: 'TrailerFleetSize',
  },  {
    formName: 'Trailer Fleet Size Authorised',
    min: 0,
    max: 10000,
    label: 'TrailerFleetSizeAuthorised',
  },
];

export const esosNotifications: IConfigSlider[] = [
  {
    formName: 'ESOS Total Energy Consumption (kWh)',
    min: 0,
    max: 6_000_000_000,
    label: 'EsosTotalEnergyConsumptionKwh',
    postfix: ' kWh',
    maxPostfix: '+',
  },
  {
    formName: 'ESOS Potential Reduction (kWh)',
    min: 0,
    max: 2_000_000_000,
    label: 'EsosPotentialReductionKwh',
    postfix: ' kWh',
    maxPostfix: '+',
  },
  {
    formName: 'ESOS Potential Reduction (GBP)',
    min: 0,
    max: 10_000_000,
    label: 'EsosPotentialReductionGbp',
    prefix: '£',
    maxPostfix: '+',
  },
  {
    formName: 'ESOS Total Savings Achieved (kWh)',
    min: 0,
    max: 2_000_000_000,
    label: 'EsosTotalSavingsAchievedKwh',
    postfix: ' kWh',
    maxPostfix: '+',
  },
  {
    formName: 'ESOS Savings By Purpose Summed (kWh)',
    min: 0,
    max: 1_000_000_000,
    label: 'EsosSavingsByPurposeKwh',
    postfix: ' kWh',
    maxPostfix: '+',
  },
  {
    formName: 'ESOS Savings By Category Summed (kWh)',
    min: 0,
    max: 1_000_000_000,
    label: 'EsosSavingsByCategoryKwh',
    postfix: ' kWh',
    maxPostfix: '+',
  },
];

export const epcEnergy: IConfigSlider[] = [
  {
    formName: 'EPC Building Count',
    min: 0,
    max: 2_000,
    label: 'EpcBuildingCountSelected',
    maxPostfix: '+',
  },
  {
    formName: 'EPC Total Floor Area',
    min: 0,
    max: 3_100_000,
    label: 'EpcTotalFloorAreaSelected',
    postfix: ' m2',
    maxPostfix: '+',
  },
  {
    formName: 'EPC Min Asset Rating',
    min: -6_500,
    max: 900,
    label: 'EpcMinAssetRatingSelected',
  },
  {
    formName: 'EPC Total Standard Emissions',
    min: 0,
    max: 215_000,
    label: 'EpcTotalStandardEmissionsSelected',
    postfix: ' tCO2e',
    maxPostfix: '+',
  },
  {
    formName: 'EPC Total Target Emissions',
    min: -600,
    max: 705_000,
    label: 'EpcTotalTargetEmissionsSelected',
    postfix: ' tCO2e',
    maxPostfix: '+',
  },
  {
    formName: 'EPC Total Building Emissions',
    min: -6_000,
    max: 310_000,
    label: 'EpcTotalBuildingEmissionsSelected',
    postfix: ' tCO2e',
    maxPostfix: '+',
  },
  {
    formName: 'EPC Buildings With Aircon',
    min: 0,
    max: 500,
    label: 'EpcBuildingsWithAirconCountSelected',
    maxPostfix: '+',
  },
];
